import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/images/avatares/avatar-bg-white.svg'


const _hoisted_1 = {
  key: 0,
  class: "w-screen h-screen bg-[#00000084] z-50 fixed top-0 flex justify-center items-center"
}
const _hoisted_2 = { class: "flex gap-8 items-start w-[90%] lg:w-[826px] h-min min-h-[234px] p-4 bg-h-primary-200 rounded-md border-b-4 border-h-secondary-600" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "time-modal"
}, null, -1)
const _hoisted_4 = { class: "mt-4 flex flex-col gap-4" }
const _hoisted_5 = { class: "flex justify-between" }
const _hoisted_6 = { class: "flex justify-end gap-2 w-full mt-10" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MessageVoice = _resolveComponent("MessageVoice")!
  const _component_Button = _resolveComponent("Button")!

  return (_ctx.showModal)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("h4", null, _toDisplayString(_ctx.title), 1),
              _createVNode(_component_MessageVoice, {
                msg: _ctx.title + '.' + _ctx.content
              }, null, 8, ["msg"])
            ]),
            _createElementVNode("p", null, _toDisplayString(_ctx.content), 1),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_Button, {
                class: "btn-outline-bg-white sm:h-9 h-11",
                onClick: _ctx.onNeedsToPause
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("labels.generic", {
                pt: `Retornar ao conteúdo`,
                en: `Return to content`,
              })), 1)
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_Button, {
                class: "btn-primary sm:h-9 h-11",
                onClick: _ctx.onOpenChat
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("labels.generic", {
                pt: `Falar no chat`,
                en: `Talk in the chat`,
              })), 1)
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}